import { Tag } from "Domain/Model/Tag/Tag";

export const UPDATE_TAG_SUCCESS = 'UPDATE_TAG_SUCCESS';

export const updateTagSuccess = (payload: Record<string, Tag>) => ({
    type: UPDATE_TAG_SUCCESS,
    payload,
});
